module.exports = __webpack_public_path__ + "img/logo_jumbosports.3378318.png";